import React from 'react';

const FornecedorContext = React.createContext();

export default FornecedorContext;
